import { render, staticRenderFns } from "./LoginProductDevelop.vue?vue&type=template&id=48353ec5&scoped=true&"
import script from "./LoginProductDevelop.vue?vue&type=script&lang=js&"
export * from "./LoginProductDevelop.vue?vue&type=script&lang=js&"
import style0 from "./LoginProductDevelop.vue?vue&type=style&index=0&id=48353ec5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48353ec5",
  null
  
)

export default component.exports